import { computed, makeObservable } from 'mobx';
import { DeviceDetailEntryStore, IDeviceDetailsConstructorOptions } from './device-detail-entry-store';
import { TransferredFileDto } from 'dto/file-transfer.dto';

export class DeviceTranferredFilesStore extends DeviceDetailEntryStore<TransferredFileDto> {
    constructor(options: IDeviceDetailsConstructorOptions) {
        super('transferred files', options);
        makeObservable(this);
    }

    /** ************************************
     * Override functions
     **************************************/
    protected async initializeData(): Promise<TransferredFileDto[]> {
        return this._devicesStore.getTransferredFiles(this.accountId, this.uid);
    }

    @computed
    public get currentTranferredFilesListing(): TransferredFileDto[] {
        return this.entities;
    }
}
